
const prdBundleIds = [];
const itsPrdIds = [];
let presentClickedBtn;
let isMobile = false;
// Select the parent element with the class 'prd-bundle-main-container'
const parentElement = document.querySelector('.prd-bundle-main-container');

// Find the hidden input elements within the parent container
const maxBundleLimit = parentElement?.querySelector('input[name="max_bundle_limit"]')?.value;
const minBundleLimit = parentElement?.querySelector('input[name="min_bundle_limit"]')?.value;
let variantUnavailable = false;



window.addPrdToBundle = function(prd, title, price, featured_image, bundlePrdId, mobileVariantIdn = null) {
  itsPrdIds.push(bundlePrdId);
  // console.log('itsPrdIds: ', itsPrdIds)
  if(variantUnavailable) return;

  const anotherImgPresent = document.querySelector('carousel-slider .slider .slider__item.is-active .product-media img');
  featured_image = anotherImgPresent.src
  
  let parent = prd.closest('.product-form');
  let prd_inv_div = parent.querySelector('.product-inventory');
  let prd_inv_qty = prd_inv_div.querySelector('.product-inventory__status').dataset.lowQty;
  prd_inv_qty = parseInt(prd_inv_qty);
  let isLowInv = !(Array.from(prd_inv_div.attributes).some(i => i.name === 'hidden'));
  let var_id = prd.closest('buy-buttons').querySelector('form input[name="id"]').value;

  // console.log({prd_inv_qty,prdBundleIds_12345: prdBundleIds.filter(item => item === var_id).length});

  if(isLowInv){
    let count = prdBundleIds.filter(item => item === var_id).length;
    if(prd_inv_qty == count ){ prd.innerHTML = "Out Of Stock"; prd.setAttribute('disabled',''); return; }
  }

  if(prdBundleIds.length > (maxBundleLimit-1)) return;
  
  if(mobileVariantIdn)presentClickedBtn = prd; isMobile = true
  // console.log('bundlePrdId: ', bundlePrdId)

  const bundleContainer = document.querySelector('.prd-bundle-container');
  const productDiv = document.createElement('div');
  productDiv.classList.add('bundle-item');

  const img = document.createElement('img');
  img.src = featured_image;
  img.alt = title;
  img.classList.add('bundle-item-image');
  productDiv.appendChild(img);

  const prdId = findIdForBundle(prd, mobileVariantIdn);  

  const removeBtn = document.createElement('span');
  removeBtn.classList.add('remove-item');
  removeBtn.innerText = '×';
  removeBtn.setAttribute('data-id', prdId);

  removeBtn.addEventListener('click', () => {
    const productId = removeBtn.getAttribute('data-id');
    const productIndex = prdBundleIds.indexOf(productId);
    if (productIndex > -1) prdBundleIds.splice(productIndex, 1); itsPrdIds.splice(productIndex, 1);
    // console.log('itsPrdIds: ', itsPrdIds)
    productDiv.remove();
    if (prdBundleIds.length < minBundleLimit) document.querySelector('.prd-bundle-AddToCart').classList.add('disabled');
    if (mobileVariantIdn) changeBtnText(prd, true); 
    else changeBtnText(document.getElementById(bundlePrdId), true);
    if (prdBundleIds.length < maxBundleLimit) disableAllBtns(false);

    // Append placeholder if there are no more products
    if (prdBundleIds.length < maxBundleLimit) {
        const placeholderDiv = document.createElement('div');
        placeholderDiv.classList.add('bundle-item');
        const placeholderImg = document.createElement('img');
        placeholderImg.src = "https://cdn.shopify.com/s/files/1/1106/6370/files/placeholder.png?v=1739168958";
        placeholderImg.alt = "Placeholder image";
        placeholderImg.classList.add('bundle-placeholder-img');
        placeholderDiv.appendChild(placeholderImg);
        bundleContainer.appendChild(placeholderDiv);
    }
  });

  productDiv.appendChild(removeBtn);

  // Check if a placeholder exists
  const placeholderImage = bundleContainer.querySelector('.bundle-placeholder-img');

  if (placeholderImage) {
      // Insert before placeholder if it exists
      bundleContainer.insertBefore(productDiv, placeholderImage.closest('.bundle-item'));
  } else {
      // If no placeholder, insert at the start of the container
      bundleContainer.appendChild(productDiv);
  }

  // Remove placeholder if product is added
  if (placeholderImage) { placeholderImage.closest('.bundle-item').remove() }

  const targetDiv = document.querySelector('.filter-container .filters .filters__inner');
  const targetDivScroll = document.querySelector('.filter-container .filters');
  if (targetDiv) {
      let scrollHeightDiv = targetDivScroll.scrollHeight + bundleContainer.scrollHeight; 
      setTimeout(()=>{ targetDivScroll.scrollTop = scrollHeightDiv },200)
      // console.log('adddded',scrollHeightDiv );
  } // else { console.log("Div not found!"); }
}


function findIdForBundle(prd, mobileVariantIdn) {
    if(!mobileVariantIdn){
        const productIdInput = document.querySelector('input[name="id"]');
        if (productIdInput) {
            thisisId(prd, productIdInput.value);
        } else {
            console.error('Product ID input not found!');
        }
        return(productIdInput.value);
    }
    else{
        thisisId(prd, mobileVariantIdn);
        return(mobileVariantIdn);
    }
}

function thisisId(prd, id) {
    prdBundleIds.push(id);
    // console.log('prdBundlesIds: ', prdBundleIds)
    if(prdBundleIds.length == maxBundleLimit ){
        disableAllBtns(true);
       
    }
    if (prdBundleIds.length >= minBundleLimit) {
        document.querySelector('.prd-bundle-AddToCart').classList.remove('disabled');
    }
    const parentContainer = prd.closest('.quickbuy-container');
    if (parentContainer) {
        const closeButton = parentContainer.querySelector('.close-detail');
        if (closeButton) {
            closeButton.click();
        }
    }
    changeBtnText(presentClickedBtn);
}

function bundlePopupOpen(btn) {  
  if(prdBundleIds.length > (maxBundleLimit-1)) return;
  presentClickedBtn = btn;
  const parentContainer = btn.closest('.image-cont');
  const quickbuyButton = parentContainer.querySelector('.quickbuy-toggle');
  if (quickbuyButton) {
      quickbuyButton.click();
  }
}

function openQuickView(e, btn, product_id){  
  e.preventDefault();
  if(prdBundleIds.length > (maxBundleLimit-1)) return;
  const parentContainer = btn.closest('.image-cont') || btn.closest('.block-inner-inner');
  presentClickedBtn = parentContainer.querySelector('.bundle-popup-open p');
  const quickbuyButton = parentContainer.querySelector('.quickbuy-toggle');
  if (quickbuyButton) {
      quickbuyButton.click();
  }
}

function changeBtnText(btn, remove=false){
    // console.log('changeBtnText btn: ', btn)
    // if(remove){
    //     btn.innerText = 'Add To Bundle';
    //     btn.closest('.bundle-popup-open').classList.remove('disabled');

    // }
    // else{
    //     btn.innerText = 'Added';
    //     btn.closest('.bundle-popup-open').classList.add('disabled');
    // }
}

function disableAllBtns(disable){
    if(disable){
        document.querySelectorAll('.bundle-popup-open p').forEach((singleBtn)=>{
            singleBtn.style.opacity = '0.5'
            singleBtn.style.cursor = 'default'
        })
    }
    else{
        document.querySelectorAll('.bundle-popup-open p').forEach((singleBtn)=>{
            singleBtn.style.opacity = '1'
            singleBtn.style.cursor = 'pointer'
        })
    }
}

// function updateBundleBtn(){
//   itsPrdIds.forEach((bundlePrdId)=>{
//     changeBtnText(document.getElementById(bundlePrdId), false);
//   })
// }

async function addBundleToCart(btn) {
    btn.innerText = 'Loading..'
    const formData = { items: prdBundleIds.map(id => ({ id, quantity: 1 })) };
    try {
        let discount_code = btn.closest('.prd-bundle-AddToCart').dataset.discountCode;
        await fetch(`/discount/${discount_code}`)

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        });
        const data = await response.json();
        if (data && data.items) {
            $('.cart-link__icon').load(location.href + ' .cart-link__icon');
            const cartDrawer = document.querySelector('cart-drawer');
            if(cartDrawer){
              cartDrawer.cartRefreshHandler();
              cartDrawer.open();
              btn.innerText = 'Add To Cart'
            }
        }
    } catch (error) {
        console.error('Error: ', error);
    }
}



document.addEventListener('DOMContentLoaded', function() {
  const element = document.querySelector('.filter-container.filter-container--side.bundle-collection');
  const mobileContainer = document.querySelector('.prd-bundle-main-container.for_mobile');
  const desktopHeading = document.querySelector('.filter-group__heading__text.for_desktop');
  const desktopContainer = document.querySelector('.prd-bundle-main-container.for_desktop');
  
  // Show the filter group items
  document.querySelectorAll('.filter-group__heading').forEach(item => item.style.pointerEvents = 'none' );

  document.querySelectorAll('.filter-group__heading.toggle-target-toggler--is-hidden').forEach(item => item.classList.remove('toggle-target-toggler--is-hidden'));
  document.querySelector('.filter-group__items.filter-group--3.toggle-target.toggle-target--hidden')?.classList.remove('toggle-target--hidden');

  // Corrected the variable names in the console log
  // console.log('mobileContainer: ', mobileContainer, ' desktopHeading: ', desktopHeading, ' desktopContainer: ', desktopContainer);

  // Handle display based on screen size
  if (window.innerWidth <= 999) {
    element?.classList.replace('filter-container--show-filters-desktop', 'filter-container--show-filters-mobile');
    if (mobileContainer) { mobileContainer.style.display = 'block'}
    if (desktopHeading) { desktopHeading.remove() }
    if (desktopContainer) { desktopContainer.remove() }
  } else {
    element?.classList.replace('filter-container--show-filters-mobile', 'filter-container--show-filters-desktop');
    if (desktopHeading) { desktopHeading.style.display = 'block' }
    if (desktopContainer) { desktopContainer.style.display = 'block' }
    if (mobileContainer) { mobileContainer.remove() }
  }
});


/* 

console.log('working custom-mw.js');

const prdBundleIds = [];
let presentClickedBtn;
// Select the parent element with the class 'prd-bundle-main-container'
const parentElement = document.querySelector('.prd-bundle-main-container');

// Find the hidden input elements within the parent container
const maxBundleLimit = parentElement.querySelector('input[name="max_bundle_limit"]').value;
const minBundleLimit = parentElement.querySelector('input[name="min_bundle_limit"]').value;

// Log the values to the console (you can also use these values in your code)
console.log('Max Bundle Limit:', maxBundleLimit);
console.log('Min Bundle Limit:', minBundleLimit);


function addPrdToBundle(prd, title, price, featured_image, bundlePrdId) {
    console.log('bundlePrdId: ', bundlePrdId)
    const bundleContainer = document.querySelector('.prd-bundle-container');
    const productDiv = document.createElement('div');
    productDiv.classList.add('bundle-item');

    const img = document.createElement('img');
    img.src = featured_image;
    img.alt = title;
    img.classList.add('bundle-item-image');
    productDiv.appendChild(img);

    const prdId = findIdForBundle(prd);

    const removeBtn = document.createElement('span');
    removeBtn.classList.add('remove-item');
    removeBtn.innerText = '×';

    removeBtn.setAttribute('data-id', prdId);

    removeBtn.addEventListener('click', () => {
        const productId = removeBtn.getAttribute('data-id');
        const productIndex = prdBundleIds.indexOf(productId);
        if (productIndex > -1) prdBundleIds.splice(productIndex, 1);
        console.log('prdBundleIds after: ', prdBundleIds)
        productDiv.remove();
        if (prdBundleIds.length < minBundleLimit ) document.querySelector('.prd-bundle-AddToCart').classList.add('disabled');
        changeBtnText( document.getElementById(bundlePrdId) , true);
        if(prdBundleIds.length < maxBundleLimit ) disableAllBtns(false);
    });

    productDiv.appendChild(removeBtn);
    bundleContainer.appendChild(productDiv);
}


function findIdForBundle(prd) {
    const productIdInput = document.querySelector('input[name="id"]');
    if (productIdInput) {
        thisisId(prd, productIdInput.value);
    } else {
        console.error('Product ID input not found!');
    }
    return(productIdInput.value);
}

function thisisId(prd, id) {
    prdBundleIds.push(id);
    console.log('prdBundlesIds: ', prdBundleIds)
    if(prdBundleIds.length == maxBundleLimit ){
        disableAllBtns(true);
       
    }
    if (prdBundleIds.length >= minBundleLimit) {
        document.querySelector('.prd-bundle-AddToCart').classList.remove('disabled');
    }
    const parentContainer = prd.closest('.quickbuy-container');
    if (parentContainer) {
        const closeButton = parentContainer.querySelector('.close-detail');
        if (closeButton) {
            closeButton.click();
        }
    }
    changeBtnText(presentClickedBtn);
}

function bundlePopupOpen(btn) {    
    if(prdBundleIds.length > (maxBundleLimit-1)) return;
    presentClickedBtn = btn;
    const parentContainer = btn.closest('.image-cont');
    const quickbuyButton = parentContainer.querySelector('.quickbuy-toggle');
    if (quickbuyButton) {
        quickbuyButton.click();
    }
}

function changeBtnText(btn, remove=false){
    console.log('changeBtnText btn: ', btn)
    if(remove){
        btn.innerText = 'Add To Bundle';
        btn.closest('.bundle-popup-open').classList.remove('disabled');

    }
    else{
        btn.innerText = 'Added';
        btn.closest('.bundle-popup-open').classList.add('disabled');
    }
}

function disableAllBtns(disable){
    if(disable){
        document.querySelectorAll('.bundle-popup-open p').forEach((singleBtn)=>{
            singleBtn.style.opacity = '0.5'
            singleBtn.style.cursor = 'default'
        })
    }
    else{
        document.querySelectorAll('.bundle-popup-open p').forEach((singleBtn)=>{
            singleBtn.style.opacity = '1'
            singleBtn.style.cursor = 'pointer'
        })
    }
}

async function addBundleToCart(btn) {
    btn.innerText = 'Loading..'
    const formData = {
        items: prdBundleIds.map(id => ({ id, quantity: 1 }))
    };
    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        });
        const data = await response.json();
        if (data && data.items) {
            window.location.href = '/cart';
            // const drawer = document.querySelector('.drawer');
            // if (!drawer.classList.contains('active')) {
            //     drawer.classList.remove("is-empty");
            //     drawer.classList.add("active");
            //     drawer.setAttribute('open', 'true');
            //     document.body.classList.add('overflow-hidden');
            // }
            // $('.drawer').load(location.href + ' .cart-drawer');
            // $('.cart-link__icon').load(location.href + ' .cart-link__icon');
        }
    } catch (error) {
        console.error('Error: ', error);
    }
}

*/



// -----------------------------------------
  
let finalSelectedVariants = [];
const discountPer = (100 - document.querySelector('[color_discount]')?.getAttribute('color_discount')) / 100 || null;

function colorsInputChangeHandler(inpElm, optName, optionSelectedValue) {
  
  // variantUnavailable = inpElm.classList.contains('is-unavailable');
  setTimeout(() => {
    let get_all_checked_inputs = inpElm?.closest('variant-picker').querySelectorAll('input:checked');
    variantUnavailable =  Array?.from(get_all_checked_inputs)?.some( i => i.classList.contains('is-unavailable'))
  
    let bundle_btn = inpElm.closest('.product-form').querySelector('.bundle-btn .add-to-bundle');
    if(variantUnavailable){ bundle_btn.innerHTML = 'Out Of Stock'; bundle_btn.setAttribute('disabled','') }
    else{ bundle_btn.innerHTML = 'Add To Bundle'; bundle_btn.removeAttribute('disabled','') }
  }, 100);

  // console.log('prdBundleIds colorsInputChangeHandler',prdBundleIds);
  


  const colorBundle = document.querySelector('.color_bundle');
  if(!colorBundle){ return } 

  const variantScript = document.querySelector('variant-picker script');
  const variantsData = JSON.parse(variantScript.textContent);
    
  if (optionSelectedValue) {
    const optionSelector = inpElm.closest('.customSwatchesCon');
    const spanHeadingColor = optionSelector.querySelector('.option-selector__label-value');
    spanHeadingColor.innerText = inpElm.value;
  }

  const checkedInputSize = document.querySelector('fieldset[data-option="Size"] input:checked');
  const allCheckedInputColor = document.querySelectorAll('fieldset[data-option="Color"] input:checked');
  let selectedOptions = [];

  if (!inpElm) {
    handleUnavailableVariants(checkedInputSize);
    return;
  }

  if (optName === 'Color') {
    handleColorSelection(inpElm, checkedInputSize);
  } else if (allCheckedInputColor?.length > 0) {
    allCheckedInputColor.forEach(checkedInputColor => handleVariantSelection(inpElm, checkedInputSize, checkedInputColor));
  }

  updateAddToCartButton();

  function handleColorSelection(inpElm, checkedInputSize) {
    selectedOptions = [checkedInputSize.value, inpElm.value];
    const selectedVariant = findSelectedVariant(selectedOptions);
    updateSelectedOptions(inpElm.name, selectedVariant?.id, selectedVariant.featured_image, selectedVariant.featured_media.id, selectedVariant.price, selectedVariant?.compare_at_price);

    if (!selectedVariant?.available) {
      removeUnavailableVariant(selectedVariant);
    }
  }

  function handleVariantSelection(inpElm, checkedInputSize, checkedInputColor) {
    selectedOptions = [inpElm.value, checkedInputColor.value];
    const selectedVariant = findSelectedVariant(selectedOptions);

    updateSelectedOptions(checkedInputColor.name, selectedVariant?.id, selectedVariant.featured_image, selectedVariant.featured_media.id, selectedVariant.price, selectedVariant?.compare_at_price);
    resetUnavailableClasses();

    const unavailableVariants = findUnavailableVariants(checkedInputSize.value);
    if (unavailableVariants?.length > 0) {
      markUnavailableVariants(unavailableVariants);
    }
  }

  function findSelectedVariant(options) {
    return variantsData.variants.find(v => v.options.every((val, index) => val === options[index]));
  }

  function updateSelectedOptions(name, value, featureImgSrc, featuredMediaId, variantPrice, compareAtPrice = null) {

  // console.log(selectedOptions,'selected options here');
  
  
    const sideImagesWrapper = document.querySelector('.side-images-wrapper');
    
    // Check if the side-images-container already exists by looking for the specific id
    let sideImageContainer = document.getElementById(`side-img-${name}`);

    const firstMainImage = document.querySelector(`.product-media-collage [data-media-id="${featuredMediaId}"]`);
    const mainImage = firstMainImage?.querySelector(`img`);
    document.querySelector('[imgActive]')?.removeAttribute('imgActive');

  if(sideImageContainer){
    const imgElement = sideImageContainer.querySelector('img');
    const mediaId = sideImageContainer.getAttribute('featured-media-id');

      if (imgElement) {
          imgElement.src = featureImgSrc.src;
          imgElement.alt = featureImgSrc.alt;
          // imgElement.removeAttribute('featured-media-id');
          sideImageContainer.setAttribute('featured-media-id', featuredMediaId);
          sideImageContainer.setAttribute('imgActive', '');
          
          sideImageContainer.setAttribute('options-atr', `${selectedOptions[0]}-----${selectedOptions[1]}`);
          

      }
      }else{
        sideImageContainer = document.createElement('div');
        sideImageContainer.classList.add('side-images-container');
        sideImageContainer.id = `side-img-${name}`;
        sideImageContainer.setAttribute('featured-media-id', featuredMediaId);
        sideImageContainer.setAttribute('imgActive', '');
        sideImageContainer.setAttribute('options-atr', `${selectedOptions[0]}-----${selectedOptions[1]}`);
        sideImageContainer.addEventListener('click',()=>{
          sideImagesMediaChange(`side-img-${name}`);
        })

        // Create the image element
        const imgElement = document.createElement('img');
        imgElement.classList.add('slider-image');
        imgElement.src = featureImgSrc.src;
        imgElement.alt = featureImgSrc.alt;

        // Append the image element to the container
        sideImageContainer.appendChild(imgElement);

        // Append the new container to the side-images-wrapper
        sideImagesWrapper.appendChild(sideImageContainer);
  
  }

    const existingOptionIndex = finalSelectedVariants.findIndex(option => option[name] !== undefined);
    if (existingOptionIndex !== -1) {
      finalSelectedVariants[existingOptionIndex][name] = value;
      finalSelectedVariants[existingOptionIndex].price = variantPrice;
      finalSelectedVariants[existingOptionIndex].compareAtPrice = compareAtPrice;
      finalSelectedVariants[existingOptionIndex].featuredMediaId = featuredMediaId;

    } else {
      finalSelectedVariants.push({ [name]: value, price: variantPrice, compareAtPrice: compareAtPrice, featuredMediaId:featuredMediaId });
    }

  }

  function handleUnavailableVariants(checkedInputSize) {
    if (allCheckedInputColor?.length > 0) {
      allCheckedInputColor.forEach(checkedInputColor => {        
        selectedOptions = [checkedInputSize.value, checkedInputColor.value];
        const selectedVariant = findSelectedVariant(selectedOptions);
        updateSelectedOptions(checkedInputColor.name, selectedVariant?.id, selectedVariant.featured_image, selectedVariant.featured_media.id, selectedVariant.price, selectedVariant?.compare_at_price);
      });
    }

    resetUnavailableClasses();
    const unavailableVariants = findUnavailableVariants(checkedInputSize.value);
    if (unavailableVariants?.length > 0) {
      markUnavailableVariants(unavailableVariants);
    }
  }

  function resetUnavailableClasses() {
    document.querySelectorAll('.customSwatchesCon input[type="radio"].is-unavailable')
      .forEach(elm => elm.classList.remove('is-unavailable'));
  }

  function findUnavailableVariants(sizeValue) {
    return variantsData.variants.filter(v => v.option1 === sizeValue && !v.available);
  }

  function markUnavailableVariants(unavailableVariants) {
    unavailableVariants.forEach(unavailableItem => {
      document.querySelectorAll(`.customSwatchesCon input[value='${unavailableItem.option2}']`)
        .forEach(elm => elm.classList.add('is-unavailable'));
      removeUnavailableVariant(unavailableItem);
    });
  }

  function removeUnavailableVariant(variant) {
    finalSelectedVariants = finalSelectedVariants.filter(obj => !Object.values(obj).some(value => value === variant.id));
  }

  function updateAddToCartButton() {
    const customAddToCartBtn = document.querySelector('.custom-add-to-cart-btn');
    if (customAddToCartBtn) {
      if (finalSelectedVariants.length > 0) {
        customAddToCartBtn.innerText = "Add To Cart";
        customAddToCartBtn.removeAttribute('disabled');
      } else {
        customAddToCartBtn.setAttribute('disabled', true);
        customAddToCartBtn.innerText = "Sold Out";
      }
    }
  }

  // console.log('hi lovovovdsjojd');
  if (optName === 'Size') {
    document.querySelector('[imgactive]')?.removeAttribute('imgactive');
    const sideImagesContainer = document.querySelectorAll('.side-images-container');
    if(sideImagesContainer?.length > 0){
      sideImagesContainer.forEach((itm,i)=>{
        if(i==0){
          itm.setAttribute('imgactive', '');
        }
      })
    }
  }
  
  const activeMediaObj = document.querySelector('.custom-media-gall-cls media-gallery');
  // console.log(activeMediaObj,'media gg');

  // if(activeMediaObj){ activeMediaObj.style.pointerEvents = 'none' }
  const boundOnVariantChange = activeMediaObj.onVariantChange.bind(activeMediaObj);

  // Calling the method manually
  boundOnVariantChange({
      type: 'on:variant:change',   // Event type (optional)
      detail: { selectedOptions: selectedOptions },  // Event data
  });


  if(finalSelectedVariants.length > 1){
    const sideImagesWrapper = document.querySelector('.side-images-wrapper');
    if(sideImagesWrapper){ sideImagesWrapper.classList.remove('hidden') }

    const customAddToCartBtn2 = document.querySelector('.custom-add-to-cart-btn');
    const allInputColorSelectors = document.querySelectorAll('fieldset[data-option="Color"] .option-selector__btns');
    if(allInputColorSelectors?.length == finalSelectedVariants?.length){ customAddToCartBtn2.style.opacity = 1 }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const colorBundle = document.querySelector('.color_bundle');
  if(colorBundle){
    // console.log('color bundle class found');
    
    colorsInputChangeHandler();
  }
});


function addToCartBundleVariants(e,btnElm){    
  e.preventDefault();


  const allInputColorSelectors = document.querySelectorAll('fieldset[data-option="Color"] .option-selector__btns');
  const qtySubmitRow = btnElm.closest('.quantity-submit-row__submit');

  if(allInputColorSelectors?.length !== finalSelectedVariants?.length){
    const customVariantSelectionMsg = qtySubmitRow.querySelector('.custom-variant-selection-msg');
    if(customVariantSelectionMsg){
      // customVariantSelectionMsg.classList.remove('hidden');
      customVariantSelectionMsg.style.visibility = 'initial'
    }
    setTimeout(()=>{
      // customVariantSelectionMsg.classList.add('hidden');
      customVariantSelectionMsg.style.visibility = 'hidden'
    },3000)
    return;
  }
  
  const allCheckedCus = document.querySelectorAll('.customSwatchesCon input:checked');

// if(finalSelectedVariants.length <= 0){
//   return;
// }

const items = finalSelectedVariants?.map(itm=>({ 'id': Object.values(itm)[0], 'quantity' : 1, properties: {_color_bundle: 'bundle'} }))
// console.log(items, 'items here');

// return

  try {
    // btnElm.closest('.quantity-submit-row__submit')?.classList.add('js-product-form');
  btnElm.setAttribute('aria-disabled', 'true');
  btnElm.classList.add('is-loading');

    let formData = {
    'items': items
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    }).then(res=>{
      
      // const cartDrawer = document.querySelector('cart-drawer');
      // if(cartDrawer){
      //   cartDrawer.cartRefreshHandler();
      //   cartDrawer.open();
      // }
      btnElm.classList.add('is-success');
        btnElm.removeAttribute('aria-disabled');

        
        setTimeout(() => {
          if(allCheckedCus.length > 0){
            allCheckedCus.forEach((elm)=>{
              elm.checked = false;
            })
          }
          btnElm.classList.remove('is-loading');
          btnElm.classList.remove('is-success');
          window.location.href = '/cart';
        }, 2000);
        })
    .catch((error) => {
      console.error('Error:', error);
    });
  } catch (error) {
    console.log(error,'err here');
    
  }
}

function stickyAtcCusButtonHanlder(e){
  e.preventDefault();
  const customAddToCartBtn = document.querySelector('.custom-add-to-cart-btn');
  if(customAddToCartBtn){
    window.scrollTo(0, 100);
    customAddToCartBtn.click();
  }
}

function sideImagesMediaChange(id){
  
  const sideImagesContainer = document.getElementById(id);
  // console.log(sideImagesContainer, 'sideImagesContainer');
  if(sideImagesContainer){
    const curOptions = sideImagesContainer.getAttribute('options-atr');
    const selectedOpts = curOptions.split("-----");


    document.querySelector('[imgactive]')?.removeAttribute('imgactive');
    //   document.querySelectorAll('.no-hidden')?.forEach(img => img.classList.replace('no-hidden', 'hidden'))
    //   handlePrdImage(document.querySelector(`.product-media-collage [data-media-id="${featuredMediaId}"]`))
    // }
    const activeMediaObj2 = document.querySelector('.custom-media-gall-cls media-gallery');
    
    const boundOnVariantChange = activeMediaObj2.onVariantChange.bind(activeMediaObj2);
    
    // Calling the method manually
    boundOnVariantChange({
      type: 'on:variant:change',   // Event type (optional)
      detail: { selectedOptions: selectedOpts },  // Event data
    });

    sideImagesContainer.setAttribute('imgactive', '');

  }

}




const targetElements = document.querySelectorAll("cart-form");
let mutationTimeout;

const free_gift_mutation = (mutationsList) => {
    clearTimeout(mutationTimeout);
    mutationTimeout = setTimeout(() => { free_gift_Updates() }, 500);
};

//////
// function removeHashFromUrl(url) { return url.replace(/:(\w+)(?=&|$)/, '') }
// function removeFreeGift(id){
//   let item = document.querySelector(`cart-form .cart-item-list .cart-item[data-product-id="${id}"]`);
//   let qty_div = item.querySelector('.cart-item__quantity .quantity');
//   let qty_inp = qty_div.querySelector('input');
//   let dec_btn = qty_div.querySelector('#updates_dec_1');
//   qty_inp.value = 1;
//   dec_btn.click();
// }
////

const free_gift_Updates = () => {
    // console.log("Cart drawer changed! Running necessary updates...");

    let free_gift_parent = document.getElementById('cart_free_gift--wrapper');
    let free_gift_progress = free_gift_parent.querySelector('[data-free-shipping-progress]')?.getAttribute('data-free-shipping-progress');
    let free_gift_prd_id = free_gift_parent.getAttribute('data-free-gift-id'); 
    let cart_drawer_list = document.querySelectorAll('cart-form .cart-item-list .cart-item');

    let free_gift_add_form = free_gift_parent.querySelector('.cart_free_gift__add_form product-form');
    let free_gift_locked = free_gift_parent.querySelector('.ctm_btn--locked');
    let cart_item_ids = Array.from(cart_drawer_list).map(e => e.getAttribute('data-product-id'));

    let count = cart_item_ids.filter(id => id === free_gift_prd_id).length; ////////////    

    if(cart_drawer_list.length > 0){ free_gift_parent.classList.remove('cart-drawer__footer--hidden') }
    else{ free_gift_parent.classList.contains('cart-drawer__footer--hidden') ? '' : free_gift_parent.classList.add('cart-drawer__footer--hidden') ; }

    if(!cart_item_ids.includes(free_gift_prd_id)){
      if(free_gift_progress != '1'){
        free_gift_add_form.style.display = 'none';
        free_gift_locked.style.display = 'block';
      }else{
        free_gift_add_form.style.display = 'block';
        free_gift_locked.style.display = 'none';
      }
    }else{

      // if(free_gift_progress != '1'){ removeFreeGift(free_gift_prd_id) } //////////////
      // else if(count > 1){ removeFreeGift(free_gift_prd_id) } /////////////

      free_gift_add_form.style.display = 'none';
      free_gift_locked.style.display = 'block';
    }
};

const observer = new MutationObserver(free_gift_mutation);
const config = { childList: true, attributes: true, characterData: true, subtree: true };
targetElements.forEach(element => observer.observe(element, config));

//////////////////////////////////////////////////////////////////////
if (window.location.href.includes('/cart')) {
  document.querySelector('.ctm_btn.add-to-cart')?.addEventListener('click', function () {
    // console.log('clicked');
    const freeGiftPrdId = document.querySelector('.cart_free_gift__add_form--var-selector')?.value;
    if (!freeGiftPrdId) return;

    const items = [{
      id: freeGiftPrdId,
      quantity: 1
    }];

    try {
      const formData = { items };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (response.ok) {
          location.reload();
        } else {
          throw new Error('Failed to add item');
        }
      })
      .catch(error => console.error('Error:', error));
    } catch (error) {
      console.error('Error:', error);
    }
  });
  
}
//////////////////////////////////////////////////////////////////////


document.addEventListener("DOMContentLoaded", function () {
  const filterConn = document.querySelector("filter-container");

  if (filterConn) {
    const productBlocks = filterConn.querySelectorAll("product-block");

    productBlocks.forEach((block) => {
      block.addEventListener("click", function () {
        // Wait for the popup to fully render
        setTimeout(() => {
          const inputRows = document.querySelectorAll(".product-form .input-row");

          if (inputRows.length > 0) {
            const swatchItemsContainer = inputRows[0];

            const swatchLists = swatchItemsContainer.querySelectorAll(
              "variant-king-combined-listing .swatches ul.swatch-view"
            );

            if (swatchLists.length > 0) {
              swatchLists.forEach((swatchList) => {
                const swatchItems = swatchList.querySelectorAll("li.swatch-view-item");

                swatchItems.forEach((swatchItem) => {
                  const imageWrapper = swatchItem.querySelector(".swatch-custom-image");
                  // console.log(imageWrapper,"=======================");
                  
                  if (imageWrapper) {
                    // Overwrite third-party click logic
                    imageWrapper.addEventListener("click", function (e) {
                      e.preventDefault();           // Prevent default browser behavior
                      e.stopPropagation();          // Stop bubbling up to parents
                      e.stopImmediatePropagation(); // ⛔ Stop other attached listeners (like the third-party one)
                      // console.log("Swatch click blocked");
                    }, true); // Use capture phase to block before 3rd party listener runs
                  }
                });
              });
            }
          }
        }, 3500); // Delay to wait for popup to fully render
      });
    });
  }
});


// =====================


// ===================== slick slider ==================
function initSlickSlider() {
  if ($(window).width() < 768) {
    $('.slider_enabled').each(function () {
      if (!$(this).hasClass('slick-initialized')) {
        $(this).slick({
          dots: false,
          arrows: true,
          infinite: false,
          speed: 800,
          slidesToShow: 4,
          slidesToScroll: 1,
          responsive: [
            { 
              breakpoint: 768,
              settings: {
                slidesToShow: 8,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 700,
              settings: {
                slidesToShow: 6,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 520,
              settings: {
                slidesToShow: 4, 
                slidesToScroll: 1,
                centerMode: false, 
                dots: false,
                arrows: true
              }
            }
          ]
        });
      }
    });
  } else {
    $('.slider_enabled.slick-initialized').slick('unslick');
  }
}

window.addEventListener("facet_filter_change", () => {
  setTimeout(() => {
    initSlickSlider();
  }, 0);
});

// Run on document ready
$(document).ready(function () {
  initSlickSlider();
});

// Run on window resize
$(window).on('resize', function () {
  initSlickSlider();
});

// Helper: Run this after AJAX content is loaded
function reInitSliderAfterAjax() {
  initSlickSlider();
}
